import { RouteRecordRaw } from 'vue-router';
import { IRouteConfigAuthMeta } from '@/shared';

const auth: IRouteConfigAuthMeta = {
  required: false,
};

export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      auth,
      title: 'Login',
      active: false,
      hideBlade: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import('@/views/auth/ForgotPassword.vue'),
    meta: {
      auth,
      title: 'Forgot Password',
      active: false,
      hideBlade: true,
    },
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: {
      auth,
      title: 'Reset Password',
      active: false,
      hideBlade: true,
    },
  },
] as RouteRecordRaw[];
